import Vue from 'vue';
import VueRouter from 'vue-router';
import Device from '../components/Login';
import Signup from '../components/Signup';
import Dashboard from '../components/Dashboard';
import Landing from "../components/Landing"
import store from '../store';
import ForgotPassword from '../components/ForgotPassword';
import ChangePassword from '../components/ChangePassword';
import Visualize from '../components/Visualization';
import Report from '../components/report/Report';
import Graph from '../components/report/Graph';
import Automl from '../components/Automl'
import Documentation from '../components/helper/Documentation'
import UnderMaintance from '../components/underMaintanicace.vue';
import NewUnderMaintance from '../components/maintence.vue'
// import loader from '../components/loader'

Vue.use(VueRouter);
const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

const routes = [
  {
    path: '/',
    component: Landing,

  },
  {
    path: '/under-Maintenance',
    component: NewUnderMaintance
  },
  {
    path: '/forgot-password',
    component: ForgotPassword
  },
  {
    path: '/change-password',
    component: ChangePassword
  },
  {
    path: '/underConstruction',
    component: UnderMaintance
  },
  {
    path: '/signup',
    component: Signup
  },
  {
    path: '/automl',
    component: Automl,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/graph/:id',
    component: Graph,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/visualize',
    component: Visualize,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/report/:id',
    component: Report,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/documentation',
    component: Documentation,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/dash',
    // name: 'HelloWorld',
    component: Dashboard,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/login',
    // name: 'Device',
    component: Device,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
